import { Component, OnInit } from "@angular/core";
import { environment } from "environments/environment";

@Component({
    selector: "dodo-id-verification-failure",
    templateUrl: "./id-verification-failure.component.html",
    styleUrls: ["./id-verification-failure.component.scss"],
    standalone: false
})
export class IdVerificationFailureComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {
        history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', () => {
            this.gotoMainSite();
        });
    }

    public gotoMainSite(): void {
        window.location.href = environment[environment.envConfigName.env].durpalApiHost;
    }
}
